import styled, { css } from 'styled-components';
import { mediaQueries } from '../../providers/MediaQueryProvider';
export const Container = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  padding: var(--space-400);
  background: var(--bg-primary);
  border-radius: var(--radius-brand);
  width: 100%;

  &:after {
    display: none;
    content: '';
    position: absolute;
    border-width: 7px;
    border-style: solid;
    ${({ pickerPosition }) => {
    if (pickerPosition === 'bottom-end' || pickerPosition === 'top-end') {
        return css `
          right: var(--space-275);
        `;
    }
    if (pickerPosition === 'left-start' ||
        pickerPosition === 'left-end' ||
        pickerPosition === 'left-center') {
        return css `
          right: -14px;
        `;
    }
    if (pickerPosition === 'right-center') {
        return css `
          left: -14px;
        `;
    }
    return css `
        left: var(--space-275);
      `;
}}

    ${({ pickerPosition }) => (pickerPosition === 'bottom-start' || pickerPosition === 'bottom-end') &&
    css `
        top: -14px;
        border-color: transparent transparent var(--bg-primary);
      `}

    ${({ pickerPosition }) => (pickerPosition === 'top-start' || pickerPosition === 'top-end') &&
    css `
        bottom: -14px;
        border-color: var(--bg-primary) transparent transparent;
      `}

    ${({ pickerPosition }) => (pickerPosition === 'left-start' ||
    pickerPosition === 'left-end' ||
    pickerPosition === 'left-center') &&
    css `
        border-color: transparent transparent transparent var(--bg-primary);
      `}

    ${({ pickerPosition }) => pickerPosition === 'right-center' &&
    css `
        border-color: transparent var(--bg-primary) transparent transparent;
      `}
  }

  &:before {
    display: none;
    content: '';
    position: absolute;
    border-width: 8px;
    border-style: solid;
    ${({ pickerPosition }) => {
    if (pickerPosition === 'bottom-end' || pickerPosition === 'top-end') {
        return css `
          right: var(--space-250);
        `;
    }
    if (pickerPosition === 'left-start' ||
        pickerPosition === 'left-end' ||
        pickerPosition === 'left-center') {
        return css `
          right: -16px;
        `;
    }
    if (pickerPosition === 'right-center') {
        return css `
          left: -16px;
        `;
    }
    return css `
        left: var(--space-250);
      `;
}}

    ${({ pickerPosition }) => (pickerPosition === 'bottom-start' || pickerPosition === 'bottom-end') &&
    css `
        top: -16px;
        border-color: transparent transparent var(--border-secondary);
      `}

    ${({ pickerPosition }) => (pickerPosition === 'top-start' || pickerPosition === 'top-end') &&
    css `
        bottom: -16px;
        border-color: var(--border-secondary) transparent transparent;
      `}

    ${({ pickerPosition }) => (pickerPosition === 'left-start' ||
    pickerPosition === 'left-end' ||
    pickerPosition === 'left-center') &&
    css `
        border-color: transparent transparent transparent var(--border-secondary);
      `}

    ${({ pickerPosition }) => pickerPosition === 'right-center' &&
    css `
        border-color: transparent var(--border-secondary) transparent transparent;
      `}
  }

  ${mediaQueries.tablet} {
    width: 318px;
    border: 1px solid var(--border-secondary);

    &:after,
    &:before {
      display: inline;
    }

    ${({ pickerPosition }) => pickerPosition === 'left-start' &&
    css `
        &:after,
        &:before {
          top: var(--space-275);
        }
      `}

    ${({ pickerPosition }) => pickerPosition === 'left-end' &&
    css `
        &:after,
        &:before {
          bottom: var(--space-275);
        }
      `}

    ${({ pickerPosition }) => (pickerPosition === 'left-center' || pickerPosition === 'right-center') &&
    css `
        &:after,
        &:before {
          top: 50%;
          transform: translateY(-50%);
        }
      `}
  }
`;
export const ColorsContainer = styled.div `
  display: flex;
  margin-bottom: var(--space-400);
`;
export const Saturation = styled.div `
  position: relative;
  overflow: hidden;
  flex: 1 0 auto;
  margin-right: var(--space-400);
`;
export const Hue = styled.div `
  position: relative;
  width: 24px;
  height: 130px;
`;
export const Alpha = styled.div `
  position: relative;
  width: 24px;
  height: 130px;
  margin-left: var(--space-400);
`;
export const Modifiers = styled.div `
  display: flex;
`;
export const Selected = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
`;
export const SelectedContainer = styled.div `
  position: relative;
  height: 24px;
  margin-bottom: var(--space-400);
`;
export const CustomPointer = styled.div `
  position: relative;
  left: ${({ alpha }) => (alpha ? -7 : -4)}px;
  top: -4px;
  width: 30px;
  height: 8px;
  border: 1px solid var(--border-secondary);
  background: var(--bg-primary);
`;
export const CustomCircle = styled.div `
  position: relative;
  top: -6px;
  left: -6px;
  width: 12px;
  height: 12px;
  border: 2px solid var(--bg-primary);
  border-radius: var(--radius-full);

  cursor: pointer;
`;
export const ButtonContainer = styled.div `
  width: 100%;

  &:first-child {
    margin-right: var(--space-400);
  }

  &:last-child {
    margin-right: 0;
  }
`;
export const Buttons = styled.div `
  display: flex;
`;
export const Input = styled.div `
  width: 50%;

  &:first-child {
    margin-right: var(--space-400);
  }
`;
export const Label = styled.div `
  position: absolute;
  top: var(--space-250);
  left: var(--space-400);
  z-index: 1;
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
  line-height: var(--font-line-height-200);
`;
export const Inputs = styled.div `
  display: flex;

  ${({ withMargin }) => withMargin &&
    css `
      margin-top: var(--space-400);
    `};
`;
